<div siqGrid fx-direction="column" fx-layout-align="center center">
  <ng-lottie [options]="animation" width="212px" height="212px"/>
  <span class="dual-bed-icon-rotated mt-neg-48"></span>
</div>
